import React, { useEffect, useState } from "react";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
const MaintenanceMarquee = () => {
    const [message, setMessage] = useState("");
    const [show, setShow] = useState(false);

    useEffect(() => {
        // Replace with your actual API endpoint
        const POLL_INTERVAL = 1 * 60 * 1000; // 15 minutes
        let intervalId;
        let currentController;

        const fetchStatus = () => {
            // abort previous fetch if still pending
            if (currentController) {
                currentController.abort();
            }
            currentController = new AbortController();
            fetch("https://prod-espro-public.s3.ap-south-1.amazonaws.com/Maintenance/status.json", { signal: currentController.signal, cache: "no-store" })
                .then((res) => res.json())
                .then((data) => {
                    // prefer the erp module if present and "on", otherwise fall back to global if it's "on"
                    const modules = Array.isArray(data?.modules) ? data.modules : [];
                    const erpModule = modules.find((m) => m?.name === "erp");
                    let base = null;

                    if (erpModule) {
                        if (erpModule.status === "on") {
                            base = erpModule;
                        } else if (data?.global?.status === "on") {
                            base = data.global;
                        }
                    } else if (data?.global?.status === "on") {
                        base = data.global;
                    }

                    if (!base) {
                        setShow(false);
                        return;
                    }

                    const now = new Date();
                    const alertStart = base.alertStartTime ? new Date(base.alertStartTime) : null;
                    const alertEnd = base.alertEndTime ? new Date(base.alertEndTime) : null;

                    // Only show if we're inside the alert window
                    if (alertStart && alertEnd && now >= alertStart && now <= alertEnd) {
                        // Format startTime/endTime into a user-friendly string with am/pm
                        const fmtOpts = {
                            month: "short",
                            day: "numeric",
                            year: "numeric",
                            hour: "numeric",
                            minute: "2-digit",
                            hour12: true,
                        };
                        const start = base.startTime ? new Date(base.startTime) : null;
                        const end = base.endTime ? new Date(base.endTime) : null;
                        const timeOpts = { hour: "numeric", minute: "2-digit", hour12: true };

                        const isSameDay = (a, b) =>
                            a.getFullYear() === b.getFullYear() &&
                            a.getMonth() === b.getMonth() &&
                            a.getDate() === b.getDate();

                        const formatSmart = (dt) => {
                            if (!dt) return "";
                            const now = new Date();
                            const tomorrow = new Date(now);
                            tomorrow.setDate(now.getDate() + 1);

                            if (isSameDay(dt, now)) {
                                return `Today ${dt.toLocaleTimeString(undefined, timeOpts)}`;
                            }
                            if (isSameDay(dt, tomorrow)) {
                                return `Tomorrow ${dt.toLocaleTimeString(undefined, timeOpts)}`;
                            }
                            // return dt.toLocaleString(undefined, fmtOpts);
                            return dt.toLocaleString("en-GB", fmtOpts);
                        };

                        let startStr = start ? formatSmart(start) : "";
                        let endStr = end ? formatSmart(end) : "";

                        // If both start and end are on the same day and that day is Today or Tomorrow,
                        // don't repeat the day label twice: "Today 10:00 AM to 1:00 PM" or "Tomorrow 10:00 AM to 1:00 PM"
                        if (start && end) {
                            const now = new Date();
                            const tomorrow = new Date(now);
                            tomorrow.setDate(now.getDate() + 1);

                            const startTimeOnly = start.toLocaleTimeString(undefined, timeOpts);
                            const endTimeOnly = end.toLocaleTimeString(undefined, timeOpts);

                            if (isSameDay(start, now) && isSameDay(end, now)) {
                                startStr = `Today ${startTimeOnly}`;
                                endStr = endTimeOnly;
                            } else if (isSameDay(start, tomorrow) && isSameDay(end, tomorrow)) {
                                startStr = `Tomorrow ${startTimeOnly}`;
                                endStr = endTimeOnly;
                            }
                        }

                        const rawMsg = base.applicationMessage || "";
                        const isValidDate = (d) => d instanceof Date && !isNaN(d.getTime());
                        const isTodayOrTomorrowString = (s) =>
                            typeof s === "string" && /^\s*(today|tomorrow)\b/i.test(s);

                        const displayStart = (isValidDate(start) || isTodayOrTomorrowString(startStr)) && startStr
                            ? startStr
                            : "--";
                        const displayEnd = (isValidDate(end) || isTodayOrTomorrowString(endStr)) && endStr
                            ? endStr
                            : "--";

                        const messageWithTimes = rawMsg
                            .replace(/<starttime>/gi, displayStart)
                            .replace(/<endtime>/gi, displayEnd);

                        setMessage(messageWithTimes);
                        setShow(true);
                        return;
                    }

                    // not in maintenance window
                    setShow(false);
                })
                .catch((err) => {
                    if (err.name === "AbortError") return; // fetch was aborted, ignore
                    setShow(false);
                });
        };

        // initial fetch immediately, then poll every 15 minutes
        fetchStatus();
        intervalId = setInterval(fetchStatus, POLL_INTERVAL);

        // cleanup on unmount: stop timer and abort any in-flight fetch
        return () => {
            if (intervalId) clearInterval(intervalId);
            if (currentController) currentController.abort();
        };
    }, []);

    // Only render the marquee if show is true
    if (!show) return null;

    return (
        <div style={{ padding: "8px 0" }}>
            <style>{`
                @keyframes blink {
                    0% { opacity: 1; transform: scale(1); }
                    50% { opacity: 0; transform: scale(1.05); }
                    100% { opacity: 1; transform: scale(1); }
                }
                .maintenance-marquee {
                    font-weight: bold;
                    color: #ffb300;
                    display: flex;
                    align-items: center;
                    gap: 8px;
                }
                .maintenance-icon {
                    animation: blink 1s linear infinite;
                }
            `}</style>
            <marquee className="maintenance-marquee">
                <WarningAmberIcon className="maintenance-icon" /> <span className="d-inline-flex">{message}</span>
            </marquee>
        </div>
    );
};

export default MaintenanceMarquee;
